export const PreconditionIndex = ['second', 'third', 'fourth', 'fifth', 'sixth'];
//# sourceMappingURL=types.js.map